import { useEffect, useState } from 'react';
import { SchoolData } from '@context/SchoolContext';

interface SkeletonLoaderProps {
  schoolData: SchoolData | null;
  schoolError?: any;
  selectedStudent: any;
  retryDelay?: number;
  initialDelay?: number;
  maxRetries?: number;
}

export const useSkeletonLoader = ({
  schoolData,
  schoolError,
  selectedStudent,
  retryDelay = 3000,
  initialDelay = 500,
  maxRetries = 3,
}: SkeletonLoaderProps) => {
  const [showSkeleton, setShowSkeleton] = useState(true);

  useEffect(() => {
    if (!selectedStudent) return;

    setShowSkeleton(true); // always show skeleton on student switch

    let retryCount = 0;
    let timer: NodeJS.Timeout;

    const checkSchoolLoaded = () => {
      if (schoolData || schoolError) {
        setShowSkeleton(false);
      } else if (retryCount < maxRetries) {
        retryCount++;
        timer = setTimeout(checkSchoolLoaded, retryDelay);
      } else {
        setShowSkeleton(false);
      }
    };

    // Slight initial delay for smooth flash
    timer = setTimeout(checkSchoolLoaded, initialDelay);

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [schoolData, schoolError, selectedStudent, retryDelay, initialDelay, maxRetries]);

  return showSkeleton;
};
